module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/2-2-37246010169295e22356f99cc75acf9b.jpg";